import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi } from '@/api/auth';
import { auth } from '@/shared/auth/storage';
import { publicRoutes } from '@/app/routes';
import { useToast } from '@/app/providers/ToastProvider';

export function PortalLoginPage() {
  const nav = useNavigate();
  const toast = useToast();
  const [phone, setPhone] = useState('');
  const [otp, setOtp] = useState<{ sessionId: string; instruction?: string } | null>(null);
  const [busy, setBusy] = useState(false);
  const pollRef = useRef<number | null>(null);

  useEffect(() => () => { if (pollRef.current) window.clearInterval(pollRef.current); }, []);

  async function start() {
    if (!phone.trim()) return toast('Утасны дугаар оруулна уу.', 'warning');
    setBusy(true);
    try {
      const r = await authApi.startOtp(phone.trim());
      setOtp({ sessionId: r.SessionId, instruction: r.DisplayInstruction });
      pollRef.current = window.setInterval(async () => {
        try {
          const st = await authApi.pollOtp(r.SessionId);
          if (st.SessionStatus === 'VERIFIED') {
            if (pollRef.current) window.clearInterval(pollRef.current);
            const res = await authApi.phoneLogin(phone.trim(), r.SessionId);
            auth.saveLogin(res);
            nav(publicRoutes.portal);
          } else if (st.SessionStatus === 'EXPIRED' || st.SessionStatus === 'FAILED') {
            if (pollRef.current) window.clearInterval(pollRef.current);
            setOtp(null);
            toast('Баталгаажуулалт амжилтгүй.', 'danger');
          }
        } catch { /* keep polling */ }
      }, 2500);
    } catch (e) {
      toast((e as Error).message, 'danger');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="cg-auth-wrap">
      <div className="ts-card cg-auth-card">
        <div className="cg-brand" style={{ padding: '0 0 18px' }}>
          <i className="bi bi-person-circle" /> Хэрэглэгчийн булан
        </div>
        <label className="ts-label">Утасны дугаар</label>
        <input className="ts-input" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="99112233" inputMode="tel" style={{ marginBottom: 14 }} />
        {otp ? (
          <div style={{ textAlign: 'center' }}>
            <div className="ts-page-sub">{otp.instruction || 'SMS-ээр баталгаажуулна уу.'}</div>
            <i className="bi bi-arrow-repeat" style={{ fontSize: '1.6rem', color: 'var(--ts-brand)' }} />
            <div className="ts-page-sub">Хүлээж байна…</div>
          </div>
        ) : (
          <button className="ts-btn ts-btn-primary" style={{ width: '100%' }} disabled={busy} onClick={start}>Код авах</button>
        )}
      </div>
    </div>
  );
}
